(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.glow.routes'
  var StickyStatesPlugin = require('@uirouter/sticky-states/_bundles/ui-router-sticky-states').StickyStatesPlugin

  require('angular')
    .module(MODULE_NAME, [
      require('./glow-config')
    ])
    .config(stickyStateLoader)
    .config(glowStateLoader)
  // .run(glowRoutePreloader)

  stickyStateLoader.$inject = ['$uiRouterProvider', '$urlRouterProvider']
  function stickyStateLoader ($uiRouterProvider, $urlRouterProvider) {
    // NOTE: You may have to comment this part out if you're trying to
    // develop other things... still working the kinks out of this whole
    // system.
    $uiRouterProvider.plugin(StickyStatesPlugin)
    // $urlRouterProvider.deferIntercept();
  }

  glowStateLoader.$inject = ['$stateProvider', '$urlServiceProvider', 'GlowConfigProvider']
  function glowStateLoader ($stateProvider, $urlServiceProvider, GlowConfigProvider) {
    var GlowConfig = GlowConfigProvider.$get()
    $urlServiceProvider.config.strictMode(false) // allow trailing slashes
    $urlServiceProvider.config.caseInsensitive(true) // allow /Test and /test to match

    /*
     * The below code is to generate a first class state
     * for every glow page. The home page will always be
     * the `glow.home` state. Any page without slashes in
     * the path will be `glow.my-path`. If you do have
     * slashes, it will generate an abstract state for each
     * nested piece until the final piece, which becomes
     * the actual state.
     */
    let definedStates = []
    let glowPages = GlowConfig.getPages()
    /*
     * sort the pages by path alphabetically so that an array of paths such as
     * /some/nested/path
     * /some/nested
     * becomes
     * /some/nested
     * /some/nested/path
     * this is to prevent actual pages, e.g. `nested` above, from being
     * falsely defined as abstract by a child state
     */
    glowPages = glowPages.sort(function (a, b) {
      var pathA = a.get('path').toUpperCase()
      var pathB = b.get('path').toUpperCase()
      if (pathA < pathB) {
        return -1
      }
      if (pathA > pathB) {
        return 1
      }

      return 0
    })

    glowPages.forEach((page) => {
      let slugs = page.get('path').split('/')
      let stateName = 'glow'

      slugs.forEach(function (slug) {
        if (slug === '') {
          stateName += '.home'
        } else {
          stateName += '.' + slug
        }

        if (definedStates.includes(stateName)) {
          return
        }

        // if this isn't nested OR it's the end of the nesting
        if (slugs.length === 1 || slug === slugs[slugs.length - 1]) {
          // create a real state!
          $stateProvider.state(stateName, {
            url: '/' + slug + '?modal&moduleId&linkedAccount',
            resolve: {
              pageConfig: loadPageConfig
            },
            sticky: true,
            views: {
              'glow-page@glow': {
                component: 'thismomentGlowPage'
              }
            }
          })
        } else {
          // create an abstract state
          $stateProvider.state(stateName, {
            url: '/' + slug,
            abstract: true,
            template: '<ui-view/>'
          })
        }

        definedStates.push(stateName)
      })
    })
  }

  // NOTE: Routing shamelessly plagiarized...
  // http://plnkr.co/edit/rIxTa9DyOB2jsk8lpE1h?p=preview
  glowRoutePreloader.$inject = ['$state', '$q', '$urlRouter']
  function glowRoutePreloader ($state, $q, $urlRouter) {
    // Find all states with 'preload: true'
    var preloadStates = $state.get().filter(function (state) { return state.preload })
    var initialPromise = $q.when() // the start of the promise chain
    var preloadPromise = preloadStates.reduce(function (prevPromise, preloadState) {
      // builds a promise chain that goes to each "preload" state one after the other
      return prevPromise.then(function () {
        // Chain $state.go promise on the previous promise
        return $state.go(preloadState, preloadState, {
          location: false // Don't update url
        })
      })
    }, initialPromise)

    preloadPromise.then(function () {
      // all states preloaded, now start listening for url changes.
      $urlRouter.listen()
    })
  }

  loadPageConfig.$inject = ['$state', '$location', 'GlowConfig']
  function loadPageConfig ($state, $location, GlowConfig) {
    // Get path, minus parent state path, then remove beginning and trailing
    // slashes. This is necessary to keep the local dev environment happy.
    const glowState = $state.get('glow')
    let idx = (glowState && glowState.url) ? glowState.url.length : 0
    const fullPath = $location.path()
    let path = fullPath.substr(idx).replace(/^\/|\/$/g, '')
    let PageConfig = GlowConfig.getPageBy('path', path)

    // Case-insensitive fallback when exact path match fails (e.g. /Test vs /test)
    if (!PageConfig && path) {
      const match = GlowConfig.getPages().find(function (p) {
        return p.get('path').toLowerCase() === path.toLowerCase()
      })
      PageConfig = match || null
    }

    if (!PageConfig) {
      $state.transitionTo('glow.page', {path: ''})
    }

    return PageConfig
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/glow-routes.js